import React from 'react';
import { TooltipPosition, Tooltip, PercentageSwitch } from 'venn-ui-kit';
import { cn } from '@/lib/utils';

export interface PercentageToggleProps {
  tooltipPosition?: TooltipPosition;
  tooltipMessage?: string;
  disabled?: boolean;
  toggled?: boolean;
  setToggled?: (toggled: boolean) => void;
  className?: string;
}

export const PercentageToggle = ({
  tooltipPosition = TooltipPosition.Bottom,
  tooltipMessage,
  disabled = false,
  toggled = false,
  setToggled,
  className,
}: PercentageToggleProps) => {
  const toggle = (
    <PercentageSwitch
      toggled={toggled}
      setToggled={setToggled}
      variant={disabled ? 'disabled' : 'enabled'}
      className={cn(`qa-slider-toggle qa-slider-toggle-toggled-${toggled.toString()}`, className)}
    />
  );
  return !tooltipMessage ? (
    toggle
  ) : (
    <Tooltip maxWidth={300} position={tooltipPosition} content={tooltipMessage || ''} usePortal>
      {toggle}
    </Tooltip>
  );
};
